import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

application.register('csv-template-generator', class extends Controller {
  static values = {
    template: String
  };

  // inspired by:
  // https://medium.com/an-idea/export-excel-files-client-side-5b3cc5153cf7#id_token=eyJhbGciOiJSUzI1NiIsImtpZCI6ImU4NjNmZTI5MmZhMmEyOTY3Y2Q3NTUxYzQyYTEyMTFiY2FjNTUwNzEiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiIyMTYyOTYwMzU4MzQtazFrNnFlMDYwczJ0cDJhMmphbTRsamRjbXMwMHN0dGcuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiIyMTYyOTYwMzU4MzQtazFrNnFlMDYwczJ0cDJhMmphbTRsamRjbXMwMHN0dGcuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMDI1NzQ4MzYyNDAxMzY4MzQ5NjgiLCJoZCI6ImZyZXRhZGFvLmNvbS5iciIsImVtYWlsIjoiYW5kcmUuZmlsaG9AZnJldGFkYW8uY29tLmJyIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsIm5iZiI6MTczMDgxNTk5NywibmFtZSI6IkFuZHLDqSBkZSBTb3VzYSBDb3N0YSBGaWxobyIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQ2c4b2NMYWdOWHByTHFSN3NIOUtqSGNwVy1JcXpLdDNkOGtfTS1neDlpTFNqNDNnaHZkNjdrPXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6IkFuZHLDqSIsImZhbWlseV9uYW1lIjoiZGUgU291c2EgQ29zdGEgRmlsaG8iLCJpYXQiOjE3MzA4MTYyOTcsImV4cCI6MTczMDgxOTg5NywianRpIjoiMjM0NjA2MjJhMDM2NmQyYTIxZjdmODEwODIwMjM2NzY3N2VhZWQ3MSJ9.WcOWaaDIcn9qCYTDPWb633ihscUTEpCl5gOfP5Y26z4wQyioCd_4cAG86X-XVJ4-eeKMHhxq5QdQLewM7ASW93PKRmstBjm3N7xGOtb6POvZ_zOqIzD405FtZP6ob8puOmCAtfzSbj3DgxvHvwnwetik9cp_airfNpfnwTMvbcKGtMD7Ha_byS7OZzlmK1Mubg4_wahxZ0jP5betyiLpGpcxnaetOmalqn8QflQ53gtvWH6PF70vXZpKa-LUeocKSNGeJWbEtqs1_3IoFM2sX8qycG074sYgnCR9VcHx0GgMEhcXXmmByT5XXhSclULbg51Yd9-FpHeBRXV-8rZBxQ
  downloadTemplateXlsx() {
    const fileName = 'template.xlsx';
    const workSheet = XLSX.utils.aoa_to_sheet(
      [this.templateValue.split(';')]
    );
    const workBook = {
      Sheets: { template: workSheet, cols: [] },
      SheetNames: ["template"],
    };
    const excelBuffer = XLSX.write(workBook, {
      bookType: "xlsx",
      type: "array"
    });
    const fileData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    FileSaver.saveAs(fileData, fileName);
  }

  downloadTemplate() {
    const blob = new Blob([this.templateValue], {
      type: 'text/csv'
    });

    FileSaver.saveAs(blob, 'template.csv');
  }
});
